export default __webpack_public_path__ + "static/media/gallery-wip-flash-suppressor_00.76754c4e.jpg";